export enum PartnerManagedAccountOrigin {
  Created = "created",
  Granted = "granted",
}
